/* eslint-disable max-len */
import { CommonTranslations } from '../interfaces/common';

const PolishCommonTranslations: CommonTranslations = {
  home: 'Strona główna',
  login: {
    title: 'Logowanie',
    labels: {
      email: 'EMAIL',
      password: 'HASŁO',
      forgotPassword: 'Zapomniałeś hasła ?',
      submit: 'Zaloguj',
      signUp: 'Zarejestruj',
    },
    errors: {
      wrongCredentials: 'Nieprawidłowy e-mail lub hasło.',
      // Z ekranu logowania korzystają uczniowie i nauczyciele — pierwsze zdanie dla jednych, drugie dla drugich
      noPassword: 'Nie pamiętasz hasła albo nie masz go jeszcze? Poproś nauczyciela o link.',
      teacherContact: 'Nauczyciel? Napisz do nas: info@elkapp.pl',
      generic: 'Nie udało się zalogować. Spróbuj ponownie za chwilę.',
      // Tylko przy innym języku niż polski — po polsku stoi tekst backendu z liczbą minut
      tooManyAttempts: 'Zbyt wiele prób logowania. Spróbuj ponownie za kilka minut.',
    },
  },
  passwordStrength: {
    label: 'Siła hasła',
    levels: {
      0: 'Zbyt łatwe',
      1: 'Bardzo łatwe',
      2: 'Dobre hasło',
      3: 'Bezpieczne hasło',
      4: 'Bardzo dobre hasło',
    },
    reminder: 'Twoje hasło musi mieć poziom 2 (dobre hasło) lub wyższy',
    title: 'Ustaw hasło',
    description: 'Upewnij się, że hasło jest wystarczająco silne',
  },
  activation: {
    labels: {
      submit: 'Aktywuj konto',
      goToLogin: 'Przejdź do logowania',
    },
    placeholders: {
      password: '●●●●●●●●',
    },
    // Teksty o nieważnym linku są dokładnie tymi, które zwraca backend: wygasły link front
    // rozpoznaje sam, bez pytania API, i ma wyglądać tak samo jak odrzucony przez serwer
    messages: {
      invalidLinkStudent: 'Link aktywacyjny jest nieważny albo konto jest już aktywne. Jeśli masz już hasło, zaloguj się. Jeśli nie, poproś nauczyciela o nowy link.',
      invalidLinkTeacher: 'Link aktywacyjny jest nieważny albo konto jest już aktywne. Jeśli masz hasło, zaloguj się.',
      genericError: 'Aktywacja konta nie powiodła się. Spróbuj ponownie za chwilę.',
    },
  },
  // Ta sama strona co aktywacja ucznia, otwarta z linku do nowego hasła
  newPassword: {
    title: 'Ustaw nowe hasło',
    submit: 'Zapisz hasło',
    messages: {
      // Dokładnie tekst backendu przy 400 — jak przy aktywacji
      invalidLink: 'Link do zmiany hasła jest nieważny albo został już użyty. Jeśli nowe hasło jest już ustawione, zaloguj się. Jeśli nie, poproś nauczyciela o nowy link.',
      success: 'Hasło zmienione. Możesz się zalogować.',
      error: 'Nie udało się zmienić hasła',
      genericError: 'Nie udało się zmienić hasła. Spróbuj ponownie za chwilę.',
    },
  },
  signUp: {
    title: 'Zarejestruj się jako nauczyciel',
    confirm: 'Potwierdź swój adres e-mail klikając na link w wiadomości e-mail, którą do Ciebie wysłaliśmy.',
    labels: {
      error: 'Rejestracja nie powiodła się. Spróbuj ponownie za chwilę.',
      email: 'Email',
      password: 'Hasło',
      name: 'Imię',
      surname: 'Nazwisko',
      submit: 'Zarejestruj',
      back: 'Wróć',
    },
    messages: {
      activationError: 'Aktywacja konta nie powiodła się',
      activationSuccess: 'Aktywacja konta. Możesz się zalogować.',
      error: 'Rejestracja nie powiodła się',
    },
    placeholder: {
      email: 'jannowak@elk.com',
      password: '●●●●●●●●',
      name: 'Jan',
      surname: 'Nowak',
    },
  },
  requestResetPassword: {
    title: 'Resetuj',
    subtitle: 'Wprowadź adres email, wyślemy Ci instrukcje',
    labels: {
      submit: 'Reset',
      goBack: 'Wróć do logowania',
    },
    placeholders: {
      email: 'Email',
    },
  },
  or: 'lub',
  validation: {
    required: 'Pole jest wymagane',
    name: {
      required: 'Imię jest wymagane',
    },
    surname: {
      required: 'Nazwisko jest wymagane',
    },
    email: {
      invalid: 'Email jest nieprawidłowy',
      required: 'Email jest wymagany',
    },
    password: {
      tooShort: 'Hasło jest nieprawidłowe',
      minLength: 'Hasło musi mieć co najmniej 10 znaków.',
      tooLong: 'Hasło jest nieprawidłowe',
      tooWeak: 'Hasło zbyt proste',
      required: 'Hasło jest wymagane',
    },
  },
  menu: {
    students: 'Uczniowie',
    wordList: 'Listy słów',
    catalog: 'Katalog obrazów',
    memory: 'Memory',
    pairing: 'Dopasowywanie',
    contact: 'Kontakt',
    profile: 'Mój profil',
    logout: 'Wyloguj',
    gamesKiddo: 'E — Easy — wersje gier dla dzieci młodszych',
    gamesOlder: 'R — Regular — wersje gier dla dzieci starszych',
  },

  cart: {
    name: 'Koszyk',
    total: 'Razem',
    toCart: 'Przejdź do koszyka',
  },
  remove: 'USUŃ',
  more: 'Zobacz więcej...',
  for: 'za',
  price: 'Cena:',
  pcs: 'szt.',
  quantity: 'Ilość',
  link: 'Link:',
  from: 'Od',
  delete: 'Usuń',
  company: {
    name: 'ELK',
  },
  footer: {
    copyright: '© {{year}} ELK. Wszelkie prawa zastrzeżone.',
    termsAndConditions: 'Regulamin',
    privacyPolicy: 'Polityka prywatności',
    contact: 'Kontakt',
    api: 'API',
    headers: {
      important: 'Ważne linki',
      services: 'Lista usług',
    },
  },
  contact: {
    title: 'Skontaktuj się z nami',
    headquarters: 'Siedziba:',
    email: 'Email: ',
    phone: 'Telefon: ',
    send: 'Wyślij',
    successMessage: 'Twoja wiadomość została wysłana',
    errorMessage: 'Nie udało się wysłać wiadomości. Spróbuj ponownie później.',
    validation: {
      required: 'Pole jest wymagane',
      email: 'Nieprawidłowy format adresu e-mail',
    },
    placeholders: {
      email: 'Twój email',
      message: 'Napisz swoją wiadomość',
    },
  },
  terms: {
    title: 'Regulamin',
  },
  privacyPolicy: {
    title: 'Polityka prywatności',
  },
  notFound: {
    title: 'Nie znaleziono',
    subtitle: 'Podana strona nie istnieje',
    backHome: 'Wróć na stronę główną',
  },
  maintenance: {
    title: 'Przerwa techniczna',
    subtitle: 'Trwają prace serwisowe. Aplikacja będzie znów dostępna wkrótce.',
    until: 'Przewidywany powrót: {{time}}',
    overdue: 'Prace przedłużają się. Pracujemy nad przywróceniem dostępu.',
    refresh: 'Odśwież',
    bypassBadge: 'Tryb serwisowy pominięty',
  },
  buttons: {
    cancel: 'Anuluj',
    save: 'Zapisz',
    delete: 'Usuń',
    create: 'Utwórz',
    close: 'Zamknij',
  },
  loading: 'Ładowanie...',
  emptyHere: 'Pusto tutaj...',
  language: {
    label: 'Język interfejsu',
  },
};

export default PolishCommonTranslations;
